import { isNumber, isString } from 'lodash-es';

/**
 * RegExp to validate a CSS height value
 */
const CSS_HEIGHT_VALIDATION_REGEX =
  /^(-?(\d*\.)?\d+)((px)|(em)|(%)|(ex)|(ch)|(rem)|(vw)|(vh)|(vmin)|(vmax)|(cm)|(mm)|(in)|(pt)|(pc))$/;
const PX_UNIT = 'px';

/**
 * Returns value if it's a valid CSS height value, or undefined otherwise.
 *
 * @param value - the value to validate.
 * @returns the validated string or undefined otherwise.
 */
function validateCSSHeight(value: string): string | undefined {
  return CSS_HEIGHT_VALIDATION_REGEX.test(value) ? value : undefined;
}

/**
 * Coerces a string or numeric value into a valid CSS height length value
 * If the value is numeric it will assume that is expressed in pixels
 * @param value - the value to coerce.
 *
 * @internal
 *
 */
export function coerceSizeValue(value?: string | number): string | undefined {
  if (isNumber(value)) {
    return `${value}${PX_UNIT}`;
  }

  if (isString(value)) {
    return validateCSSHeight(value);
  }

  return undefined;
}
